<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="localShow"
      persistent
      :max-width="width"
      :fullscreen="fullscreen"
      :scrollable="true"
    >
      <v-card>
        <v-card-title class="headline white--text green darken-1">
          <v-layout row wrap>
            <slot name="title"></slot>

            <v-spacer></v-spacer>

            <v-flex class="text-xs-right">
              <v-btn @click="close" icon small flat color="white">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text :style="fullscreen ? 'height: 90%' : ''">
          <slot></slot>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <slot name="actions"></slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    width: {
      type: [Number, String],
      default: '600'
    },
    fullscreen: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  },
  computed: {
    localShow() {
      return this.show;
    }
  }
};
</script>
